module.exports = __webpack_public_path__ + "img/download-on-the-app-store.010f1c80.png";